<template>
  <b-modal
      v-model="show"
      v-if="show"
      centered
      hide-footer
      :title="editing ? 'ویرایش کارشناس تغذیه' : 'افزودن کارشناس تغذیه جدبد'"
      :no-close-on-backdrop="true"
      size="sm"
  >
    <b-row>
      <b-col class="col-md-12">
        <b-form-group
            label="کاربر"
            class="d-inline-block full-width"
        >
          <user-select v-model="form.UserId" />
        </b-form-group>
      </b-col>
      <b-col md="12">
        <b-form-group
            label="مدرک تحصیلی"
            label-for="DegreeEducation"
        >
          <b-form-input
              id="DegreeEducation"
              v-model="form.DegreeEducation"
              autocomplete="off"
          />
        </b-form-group>
      </b-col>
      <b-col md="12">
        <b-form-group
            label="شماره نظام پزشکی"
            label-for="NezamNum"
        >
          <b-form-input
              id="NezamNum"
              v-model="form.NezamNum"
              autocomplete="off"
          />
        </b-form-group>
      </b-col>
      <b-col v-if="editing" md="12">
        <b-form-group class="mt-1">
          <b-form-checkbox
              v-model="form.IsActive"
              class="custom-control-success"
          >
            فعال
          </b-form-checkbox>
        </b-form-group>
      </b-col>
    </b-row>
    <div class="text-center mt-2">
      <b-overlay :show="loading" rounded spinner-small class="d-inline-block">
        <b-button
            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
            type="submit"
            variant="primary"
            class="mr-1"
            :disabled="loading"
            @click="submit"
        >
          ذخیره
        </b-button>
      </b-overlay>
      <b-button
          v-ripple.400="'rgba(186, 191, 199, 0.15)'"
          variant="outline-secondary"
          @click="$emit('update:show', !show)"
      >
        انصراف
      </b-button>
    </div>
  </b-modal>
</template>

<script>
import UserSelect from "@/tools/user.vue";
export default {
  name: "nutritionistForm",
  props: {
    show: { type: Boolean, default: false },
    item: { type: Object, default: null },
  },
  components: { UserSelect },
  data() {
    return {
      loading: false,
      form: {
        UserId: '',
        NezamNum: '',
        DegreeEducation: '',
        IsActive: true,
      }
    }
  },
  computed: {
    editing() {
      return this.item && this.item.UserId
    }
  },
  watch: {
    show: {
      immediate: true,
      handler(val) {
        if (!val) this.form = {
          UserId: '',
          NezamNum: '',
          DegreeEducation: ''
        }
      }
    },
    item: {
      immediate: true,
      handler(val) {
        if (val) {
          this.form = val
        }
      }
    }
  },
  methods: {
    submit() {
      this.loading = true
      let url = this.editing ? this.$api.nutritionist.update : this.$api.nutritionist.add
      this.$http.post(url, this.form).then(() => {
        this.loading = false
        this.$emit('update:show', !this.show)
        this.$emit('done')
      }).finally(() => {
        this.loading = false
      })
    },
  }
}
</script>